// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type FreeDayListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SearchMandantFreedaysQuery = {
  year?: number;
  countryCode?: string;
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSearchMandantFreedays(): (
  mandantId: string,
  query: SearchMandantFreedaysQuery
) => Promise<FreeDayListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (mandantId, query = {}) =>
      (await getAPI()).mandanten.searchMandantFreedays({ mandantId, ...query }),
    [getAPI]
  );
}
